"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAuthenticationModule = exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Auth = function Auth() {
  var _this = this;

  _classCallCheck(this, Auth);

  _defineProperty(this, "authModule", void 0);

  _defineProperty(this, "getAuthorizationHeader", function (uri) {
    if (_this.authModule) {
      return _this.authModule.getAuthorizationHeader(uri);
    }

    return Promise.resolve();
  });

  _defineProperty(this, "isAuthenticated", function (state) {
    if (_this.authModule) {
      return _this.authModule.isAuthenticated(state);
    }

    return Promise.resolve(true);
  });

  _defineProperty(this, "login", function () {
    if (_this.authModule) {
      _this.authModule.login();
    } else {
      throw new Error('The rest-client authentication module has not been initialised');
    }
  });

  _defineProperty(this, "setAuthenticationModule", function (authModule) {
    if (!authModule.getAuthorizationHeader) {
      throw new Error('Missing getAuthorizationHeader method');
    }

    if (!authModule.isAuthenticated) {
      throw new Error('Missing isAuthenticated method');
    }

    if (!authModule.login) {
      throw new Error('Missing login method');
    }

    _this.authModule = authModule;
  });
};

var auth = new Auth();
var _default = auth;
exports["default"] = _default;

var setAuthenticationModule = function setAuthenticationModule(authModule) {
  auth.setAuthenticationModule(authModule);
};

exports.setAuthenticationModule = setAuthenticationModule;